import BuyData from '../../pages/PayBills/BuyData';
import React, { useState } from 'react';
import { object, string } from 'yup';
import { observer } from 'mobx-react';
import constant from '../../utils/constant';
import { billStore } from '../../stores';
import { phoneRegExp } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

function BuyDataContainer({ closeModal, setShowSurvey }) {
	const [pinContent, setPinContent] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.PAYBILLSBUYAIRTIMEDATA);

	const validationSchema = () => object({
		phone: string().matches(phoneRegExp, 'Phone number is not valid').required("Please enter phone number"),
		dataId: string().required("Please select data bundle"),
	});

	const onSubmit = async payload => {
		payload.controller = 'buyData';
		delete payload.networkId;
		delete payload.networkName;
		delete payload.plan;
		localStorage.setItem(constant.RouteParams, JSON.stringify(payload));
		setPinContent(true);
	};

	const plans = (network) => {
		const plans = JSON.parse(localStorage.getItem(`data-${network}-plans`));
		return network === '' ? [] : plans;
	}

	return (
		<div>
			<BuyData
				bill={billStore.copiedBill}
				onSubmit={onSubmit}
				plans={plans}
				validationSchema={validationSchema}
				closeModal={closeModal}
				pinContent={pinContent}
				setShowSurvey={setShowSurvey}
				needFeedback={needFeedback}
			/>
		</div>
	);
}

export default observer(BuyDataContainer);
